module.exports = __webpack_public_path__ + "img/petrifactionImg3.3da3271c.jpg";